module.exports = __webpack_public_path__ + "img/close_menu.3bbe74fb.svg";